import { createChallenge } from './functions/create-challenge';
import { getChallengesForList } from './functions/get-challenges-for-list';
import { getChampionshipChallenges } from './functions/get-championship-challenges';

export default {
  createChallenge,
  getChallengesForList,
  getChampionshipChallenges,
};
